export default (...args) => {
  return fetch(...args).then(response => {
    if (response.ok) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  });
};
